export enum RegistrationSteps {
  welcome = 0,
  subsidy = 1,
  certificate = 2,
  challenges = 3,
}
